<mat-card appearance="outlined" class="mb-10 col-sm-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
    <mat-card-header>
        <mat-card-title>
            <mat-icon>home</mat-icon> {{ greeting$ }}, {{ userService.activeUserDisplayName | titlecase }}
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="row p-2">
      <div class="col-md-12 col-lg-6 d-inline-block p-1">
        <mat-card appearance="outlined" class="mat-elevation-z2">
          <mat-card-header>
            <mat-card-title>
              <h1><mat-icon>settings_accessibility</mat-icon> &nbsp;Search Growers</h1>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content style="text-align: right;">
            <app-grower-recent [limit]="7" (selected)="router.navigate(['growers', $event.id])"></app-grower-recent>
            <br/>
            <button routerLink="/growers" mat-raised-button style="" color="accent">Growers <mat-icon>search</mat-icon></button>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-md-12 col-lg-6 d-inline-block p-1">
        <mat-card appearance="outlined" class="mat-elevation-z2">
          <mat-card-header>
            <mat-card-title>
              <h1><mat-icon>today</mat-icon> &nbsp;Latest Events</h1>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content style="text-align: right;">
            <mat-list class="odd-even-list">
              <mat-list-item
                class="d-flex"
                [routerLink]="'/events/' + event.id"
                *ngFor="let event of dataService.events | async | slice:0:5">
                <div class="d-flex">
                  <app-category-tag class="" style="vertical-align: middle;" [category]="event.category" [name]="true"></app-category-tag>
                  <span class="ellipsis" style="line-height: 42px; vertical-align: middle; margin-left: 10px;">{{ event.date | amFromUnix | amDateFormat:'DD/MM/YYYY' }} - {{ event.name }}</span>
                </div>
              </mat-list-item>
            </mat-list>

            <br/>
            <button routerLink="/events" mat-raised-button color="accent">Events <mat-icon>search</mat-icon></button>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="col-12 d-inline-block p-1" *ngIf="flaggedProperties.length || flaggedPropertiesUser.length">
        <mat-card appearance="outlined" class="mat-elevation-z2">
          <mat-card-header>
            <mat-card-title>
              <h1><mat-icon>flag</mat-icon> &nbsp;Properties Requiring Follow-up</h1>
            </mat-card-title>
            <mat-card-subtitle>
              <mat-slide-toggle #onlyMyFollowup>Show only follow-ups for my contacts</mat-slide-toggle>
            </mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>

            <!--<mat-chip-set class="d-flex">
              <mat-chip-option [matTooltip]="flaggedProperty.id + ''"
                        class="clickable ellipsis chip mat-elevation-z2 highlighted"
                        (click)="router.navigate(['growers', flaggedProperty.id])"
                        selected
                        [color]="'primary'"

              >
                <div class="label">{{ flaggedProperty | propSummaryName: 40 }}</div>
              </mat-chip-option>
              <div class="chip" style="height: 0; padding-top: 0; padding-bottom: 0;"></div>
              <div class="chip" style="height: 0; padding-top: 0; padding-bottom: 0;"></div>
              <div class="chip" style="height: 0; padding-top: 0; padding-bottom: 0;"></div>
            </mat-chip-set>-->

            <div class="d-flex flex-wrap">
              <app-button-tag
                *ngFor="let flaggedProperty of (onlyMyFollowup.checked ? flaggedPropertiesUser : flaggedProperties)"
                class="m-1"
                icon="settings_accessibility"
                (itemClick)="router.navigate(['growers', flaggedProperty.id])"
                [matTooltip]="flaggedProperty.id + ''"
                [label]="flaggedProperty | propSummaryName: 40"
                [color]="primaryColor">
              </app-button-tag>
            </div>


          </mat-card-content>
        </mat-card>
      </div>

      <div class="col-12 d-inline-block p-1">
        <mat-card appearance="outlined" class="mat-elevation-z2">
          <mat-card-header>
            <mat-card-title>
              <h1><mat-icon>insights</mat-icon> &nbsp;Your Grower Interactions</h1>
            </mat-card-title>
            <mat-card-subtitle>
              A sum of all extension activities and event attendance.
            </mat-card-subtitle>
          </mat-card-header>
          <mat-card-content *ngIf="reportLoading">
            <mat-spinner class="ml-auto mr-auto mt-5 mb-5 d-block"></mat-spinner>
            <br/><br/>
          </mat-card-content>
          <mat-card-content *ngIf="!reportLoading && chartOptions.series.length">
            <highcharts-chart
              [Highcharts]="Highcharts"
              [options]="chartOptions"
              style="width: 100%; height: 400px; display: block;"
            ></highcharts-chart>
            <br/>
            <button routerLink="/reports" mat-raised-button color="accent">View Reports <mat-icon>insights</mat-icon></button>
          </mat-card-content>
          <mat-card-content *ngIf="!reportLoading && chartOptions.series.length === 0" class="text-center">
            <h2 class="mt-5">No weekly contacts to show</h2>
            <br/>
            <button routerLink="/reports" mat-raised-button color="accent">View Reports <mat-icon>insights</mat-icon></button>
          </mat-card-content>
        </mat-card>
      </div>

    </mat-card-content>
</mat-card>
